export default {
  bookingCtaClass: 'gtmBookingCta',
  surveyCtaClass: 'gtmSurveyCta',
  faqToggleClass: 'gtmFaqToggleButton',
  locationsDropdownClass: 'gtmToggleLocationDropdown',
};
